
export class Language {
  cat: string;
  val: string;

  constructor(cat: string, val: string) { 
    this.cat = cat;
    this.val = val;
  }
}
